<template>
    <component v-if="selectedFlow"
               :is="selectedFlow"
               @appointment-selected="handleChange($event)" />
    <div v-if="showOkButton"
         class="pt-5 vff-animate f-fade-in f-enter">
        <button ref="button"
                class="o-btn-action"
                type="button"
                href="#"
                @click.prevent="goToConfirmation()">
            <span>{{ $t('appointment_form_page.continue') }}</span>
        </button>
    </div>
</template>

<script lang="ts">
import { defineComponent, defineAsyncComponent, PropType, ref } from 'vue';
import { useAppointmentStore } from "~concierge/store/appointmentStore"
import { Appointment } from "~concierge/types/AppointmentTypes"
import { ConciergeAppointmentQuestionFlow } from "~types/concierge-enum";


export default defineComponent({
    components: {
        TestDriveAppointment: defineAsyncComponent(() => import('~concierge/components/AppointmentQuestionComponents/TestDriveAppointment.vue')),
        FreeAppointment: defineAsyncComponent(() => import('~concierge/components/AppointmentQuestionComponents/FreeAppointment.vue')),
        AdviserSelectionAppointment: defineAsyncComponent(() => import('~concierge/components/AppointmentQuestionComponents/AdviserSelectionAppointment.vue')),
    },
    setup() {
        const appointmentStore = useAppointmentStore();
        const showOkButton = ref<boolean>(false);
        return {
            appointmentStore,
            showOkButton
        };
    },
    props: {
        selectedFlow: {
            type: String as PropType<ConciergeAppointmentQuestionFlow>,
            required: true
        },
    },
    emits: ['goToConfirmation'],

    watch: {
        selectedFlow(newValue, oldValue) {
            if (newValue != oldValue) {
                this.showOkButton = false
                this.appointmentStore.resetData()
                this.appointmentStore.resetAppointment()
            }
        }
    },
    methods: {
        handleChange(appointment: Appointment) {
            appointment.flow = this.selectedFlow
            this.appointmentStore.setAppointment(appointment)
            this.showOkButton = true
        },
        goToConfirmation(): void {
            this.$emit('goToConfirmation');

        }
    },
});
</script>

<style scoped>
/* Styles CSS if necessary */
</style>
